import { getPrintFormPdf } from '../services/api';

export const handlePrintFormOpen = async (printFormId: string) => {
  const { data } = await getPrintFormPdf(printFormId);
  const fileURL = URL.createObjectURL(data);
  window.open(fileURL);

  return fileURL;
};
